/**
 * Custom modifications for Junip review widgets
 * Modifies the star rating display to show only one star instead of five
 */

(function() {
  'use strict';

  // Function to modify Junip star ratings to show single star
  function modifyJunipStarRatings() {
    // Wait for Junip elements to be rendered
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Check for Junip star rating containers
        const starContainers = document.querySelectorAll('.junip-product-summary-star-ratings-container');
        
        starContainers.forEach(function(container) {
          // Check if already modified
          if (container.getAttribute('data-single-star-modified')) {
            return;
          }
          
          // Get all star elements
          const stars = container.querySelectorAll('.junip-product-summary-star');
          
          if (stars.length > 0) {
            // Keep only the first star visible, hide ALL others
            stars.forEach((star, index) => {
              if (index === 0) {
                // Ensure first star is visible
                star.style.display = 'inline-flex';
                star.style.visibility = 'visible';
              } else {
                // Hide all other stars
                star.style.display = 'none';
                star.style.visibility = 'hidden';
              }
            });
            
            // Mark as modified to avoid re-processing
            container.setAttribute('data-single-star-modified', 'true');
            
            // Add custom class for styling
            container.classList.add('junip-single-star');
          }
          
          // Extract and display rating value from aria-label
          const ariaLabel = container.getAttribute('aria-label');
          if (ariaLabel) {
            // Extract rating value (e.g., "4.63" from "4.63 stars")
            const ratingMatch = ariaLabel.match(/(\d+\.?\d*)\s*star/i);
            if (ratingMatch) {
              const ratingValue = ratingMatch[1];
              
              // Find the review count element and update it
              const reviewCountElement = container.closest('.junip-product-summary')?.querySelector('.junip-product-summary-review-count');
              if (reviewCountElement) {
                // Update to show ONLY the rating value: "4.63"
                reviewCountElement.textContent = ratingValue;
                
                // Add styling to the review count element
                reviewCountElement.style.fontSize = '14px';
                reviewCountElement.style.fontFamily = 'Instrument Sans';
                reviewCountElement.style.marginLeft = '5px';
                reviewCountElement.style.fontWeight = '400';
              } else {
                // If review count element doesn't exist, create one
                const newRatingElement = document.createElement('span');
                newRatingElement.className = 'junip-product-summary-review-count';
                newRatingElement.textContent = ratingValue;
                newRatingElement.style.fontSize = '14px';
                newRatingElement.style.fontFamily = 'Instrument Sans';
                newRatingElement.style.marginLeft = '5px';
                newRatingElement.style.fontWeight = '400';
                
                // Insert after the star container
                if (container.parentNode) {
                  container.parentNode.insertBefore(newRatingElement, container.nextSibling);
                }
              }
            }
          }
        });
        
        // Also check for sticky panel specific containers
        const stickyContainers = document.querySelectorAll('.sticky-junip-review .junip-product-summary-star-ratings-container');
        
        stickyContainers.forEach(function(container) {
          if (container.getAttribute('data-sticky-modified')) {
            return;
          }
          
          const stars = container.querySelectorAll('.junip-product-summary-star');
          
          if (stars.length > 0) {
            // For sticky panel, show first star and hide all others
            stars.forEach((star, index) => {
              if (index === 0) {
                star.style.display = 'inline-flex';
                star.style.visibility = 'visible';
              } else {
                star.style.display = 'none';
                star.style.visibility = 'hidden';
              }
            });
            
            container.setAttribute('data-sticky-modified', 'true');
          }
          
          // Extract rating for sticky panel
          const ariaLabel = container.getAttribute('aria-label');
          if (ariaLabel) {
            const ratingMatch = ariaLabel.match(/(\d+\.?\d*)\s*star/i);
            if (ratingMatch) {
              const ratingValue = ratingMatch[1];
              
              // Update or create review count element in sticky panel
              const stickyReview = container.closest('.sticky-junip-review');
              if (stickyReview) {
                let reviewCountElement = stickyReview.querySelector('.junip-product-summary-review-count');
                if (reviewCountElement) {
                  // Update to show ONLY the rating value: "4.63"
                  reviewCountElement.textContent = ratingValue;
                } else {
                  // Create new element for sticky panel if it doesn't exist
                  reviewCountElement = document.createElement('span');
                  reviewCountElement.className = 'junip-product-summary-review-count';
                  reviewCountElement.textContent = ratingValue;
                  reviewCountElement.style.fontSize = '14px';
                  reviewCountElement.style.fontFamily = 'Instrument Sans';
                  reviewCountElement.style.color = '#262626';
                  reviewCountElement.style.marginLeft = '5px';
                  if (container.parentNode) {
                    container.parentNode.appendChild(reviewCountElement);
                  }
                }
              }
            }
          }
        });
      });
    });
    
    // Start observing the document for Junip elements
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Also run immediately in case elements are already loaded
    setTimeout(function() {
      const event = new Event('junipModifyStars');
      document.dispatchEvent(event);
    }, 100);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', modifyJunipStarRatings);
  } else {
    modifyJunipStarRatings();
  }
  
  // Also listen for Junip-specific events if available
  window.addEventListener('junip:loaded', modifyJunipStarRatings);
  window.addEventListener('junip:reviews:loaded', modifyJunipStarRatings);
  
  // Expose function globally for debugging
  window.modifyJunipStarRatings = modifyJunipStarRatings;
})();

// Additional CSS injection for better control
(function() {
  const style = document.createElement('style');
  style.textContent = `
    /* Hide all stars except the first one globally */
    .junip-product-summary-star:not(:first-child) {
      display: none !important;
      visibility: hidden !important;
    }
    
    /* Ensure first star is always visible */
    .junip-product-summary-star:first-child {
      display: inline-flex !important;
      visibility: visible !important;
    }
    
    /* Specific for containers with our custom class */
    .junip-single-star .junip-product-summary-star:not(:first-child) {
      display: none !important;
      visibility: hidden !important;
    }
    
    /* Specific styles for sticky panel */
    .sticky-junip-review .junip-product-summary-star-ratings-container {
      display: inline-flex;
      align-items: center;
    }
    
    .sticky-junip-review .junip-product-summary-star:not(:first-child) {
      display: none !important;
      visibility: hidden !important;
    }
    
    .sticky-junip-review .junip-product-summary-star:first-child {
      display: inline-flex !important;
      visibility: visible !important;
    }
    
    /* Force black color for ALL star elements */
    .junip-product-summary-star,
    .junip-product-summary-star svg,
    .junip-product-summary-star svg path,
    .junip-product-summary-star svg polygon,
    .junip-product-summary-star svg * {
      fill: #000000 !important;
      color: #000000 !important;
    }
    
    /* Adjust star size in sticky panel */
    .sticky-junip-review .junip-product-summary-star svg {
      width: 16px !important;
      height: 16px !important;
      fill: #000000 !important;
    }
    
    /* Style for review count */
    .junip-product-summary-review-count {
      font-size: 14px !important;
      font-family: 'Instrument Sans' !important;
      color: #262626 !important;
      margin-left: 5px !important;
    }
    
    /* Override any Junip default gray colors */
    .junip-stars-filled,
    .junip-stars-outline {
      fill: #000000 !important;
    }
    
    /* Ensure filled stars are black */
    .junip-product-summary-star .junip-stars-filled path {
      fill: #000000 !important;
    }
  `;
  document.head.appendChild(style);
})();